:host {
  @apply block w-full h-full bg-white;
}
